import { useState, useEffect } from 'react';
import { OrdersService, type PedidoResponse } from '../services/orders/orders.service';

interface UseClientePedidosReturn {
  pedidos: PedidoResponse[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useClientePedidos(): UseClientePedidosReturn {
  const [pedidos, setPedidos] = useState<PedidoResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPedidos = async () => {
    setLoading(true);
    setError(null);

    try {
      const userDataStr = localStorage.getItem('userData');
      if (!userDataStr) {
        setError('No se encontró información del usuario');
        setLoading(false);
        return;
      }

      const userData = JSON.parse(userDataStr);
      const email = userData.email;

      if (!email) {
        setError('No se encontró el email del cliente');
        setLoading(false);
        return;
      }

      const response: any = await OrdersService.getByEmail(email, 1, 100);
      if (response.success) {
        setPedidos(response.data || []);
      } else {
        setError(response.message || 'Error al cargar los pedidos');
      }
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Error al cargar los pedidos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPedidos();
  }, []);

  return {
    pedidos,
    loading,
    error,
    refetch: fetchPedidos,
  };
}
